import * as types from '../constants/ActionTypes';

const initialState = {
  isChatBotLoaded: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.SET_CHAT_BOT_LOADED:
      return Object.assign({}, state, { isChatBotLoaded: true });
    case types.SET_CHAT_BOT_ERROR:
      return Object.assign({}, state, { isChatBotLoaded: false });
    default:
      return state;
  }
}
